import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    gap: '15px',
  },
  overflow: {
    overflowY: 'scroll',
    flex: 1,
  },
  bottomButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    flexWrap: 'wrap',
  },
  button: {
    width: 'fit-content',
    alignSelf: 'flex-start',
    color: theme.palette.colors.darkGrey,
    fontSize: '0.875rem',
    marginLeft: '-0.375rem',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
  },
  continueButton: {
    width: 'fit-content',
    alignSelf: 'flex-end',
  },
  selectorContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  updateButton: {
    height: '32px',
  },
  metaLine: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paginationInfoText: {
    fontSize: '12px',
    color: '#000',
    margin: 0,
  },
  perPageOptions: {
    fontSize: '12px',
    color: '#000',
    position: 'relative',
    cursor: 'pointer',
  },
  exceedAlert: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    gap: '10px',
    padding: '8px 10px',
  },
  exceedIcon: {
    color: theme.palette.primary.main,
  },
  exceedText: {
    margin: 0,
  },
  controls: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
}));
